var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8 7.5v2l4-4.018L8 1.5v2s-6.639 1.072-8 7c2.898-3.103 8-3 8-3z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }